<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild hearder-box">
    <!-- 电脑导航 -->
    <div class="header-nav container computer-show">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/image/logo.png">
        <span style="font-size: 12px;color: #fff;">诺鲸智能科技（徐州）有限公司</span>
      </div>
      <div class="flex-ul-far">
        <!-- :class="[index==navIndex?'active':'',index==1?'li-heigt':'']" -->
        <ul class="flex-ul">
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="navClick(index,item.path)"
            class="flex-li"
            data-target="#menu"
          >
            <router-link :to="item.path">
              <div style="color: #fff;" :class="item.id==2?'li-line-add':''">{{item.name}}</div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="header-nav-phone">
        <span>服务电话 400-117-1567</span>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs phone-show">
      <!-- <div class="header-nav-m-logo">
        <span style="font-size: 12px;color: #fff;">诺鲸智能科技（徐州）有限公司公司</span>
      </div> -->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div>
          <span style="font-size: 12px;color: #fff;">诺鲸智能科技（徐州）有限公司公司</span>
        </div>
        <div
          class="header-nav-m-menu-wrapper"
          data-target="#menu"
          @click="menuClick"
        >
          <!-- <span :class="menuClass"></span> -->
           <img v-show="!isColl" class="img-menu" src="https://zhuanqianya.oss-cn-hangzhou.aliyuncs.com/20241017/4604af3d64254ca683829b9e3a27bb37.png" alt="" srcset="">
           <img v-show="isColl" class="img-menu" src="https://zhuanqianya.oss-cn-hangzhou.aliyuncs.com/20241017/37f42e15d7dd41e79a7ddbdfe60a5330.png" alt="" srcset="">
        </div>
        <!-- data-toggle="collapse" -->
        <!-- 导航内容 -->
        <ul id="menu" :class="[isColl?'':'collapse','header-nav-m-wrapper','ikjk']">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="[index==navIndex?'active':'',index==1?'li-heigt':'']"
            @click="navClick(index,item.path)"
            data-target="#menu"
          >
            <router-link :to="item.path">
              <div :class="item.id==2?'li-line-add':''">{{item.name}}</div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      isColl:false,
      isOver:false,//是否显示产品子菜单
      navCheckIndex:0,
      isShow:false,//是否显示产品子菜单
      navList: [
        {
          name: "公司简介",
          path: "#gsjj",
          id:1,
          isChildren: false
        },
        {
          name: "合作伙伴",
          path: "#hzhb",
          id:2,
          isChildren: true,
          children: [
            
          ]
        },
        {
          name: "核心业务",
          id:3,
          path: "#hxyw",
          isChildren: false,
          children: []
        },
        {
          name: "联系我们",
          id:4,
          path: "#footer",
          isChildren: false,
          children: []
        },
      ],
    };
  },
  mounted() {
    
  },
  methods: {
    getlocal(e){
      let elm=document.getElementById(e)
      if(e){
        elm.scrollIntoView(true)
      }
    },
    navClick(index, path) {
      window.location.hash = path
      this.isColl=false
      // this.navIndex = index;
      // this.navCheckIndex = index;
      // localStorage.setItem('aId','')
      // sessionStorage.setItem('navIndex',index)
      // this.menuName = name;

    },
    menuClick() {
      console.log(123)
      this.isColl=!this.isColl
      // this.menuClass = "glyphicon glyphicon-menu-down";
      // if (this.menuClass == "glyphicon glyphicon-menu-down") {
      //   this.menuClass = "glyphicon glyphicon-menu-up";
      // } else {
      //   this.menuClass = "glyphicon glyphicon-menu-down";
      // }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: rgba(255, 255, 255, 0);;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #081120;
}
.hearder-box{
  position: relative;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  max-width: 100% !important;
  padding-left: 10%;
  padding-right: 10%;
  position:fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  height: 46px;
}
@media screen and (min-width: 996px) {
  #header .header-nav{
    display: flex;
    align-items:center;
    justify-content: space-between;
    background-color: rgba(2, 12, 58, 0.8);
  }
  /* 导航栏logo */
 .header-nav .header-nav-logo {
    width: 240px;
    height: 38px;
    float: left;
    position: relative;
  }
  .flex-ul-far{
    width: 360px;
  }
  .flex-ul{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin:0px;
    line-height: 34px;
  }
  .flex-li{
    color: #fff;
  }
  /* 导航栏logo图片 */
 .header-nav .header-nav-logo img {
    /* width: 90px;
    height: 56px; */
    width: 60px;
    height: 35px;
    display: inline-block;
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto; */
  }
  .header-nav-phone{
    width: 170px;
    height: 34px;
    float: right;
    position: relative;
    text-align: center;
    line-height: 34px;
    color: #fff;
    background-color: #5D62F7;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
  }
  .header-nav-phone span{
    font-weight: 600;
  }
  
  
}
@media screen and (max-width: 768px) {
  .header-nav-m-logo{
    background-color: #020A2D;
    color: #fff;
    text-align: center;
  }
}

@media screen and (max-width: 997px) {
  /* 手机导航 */

  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    /* background: #474747; */
    background: #081120;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -13px;
    width: 34px;
    height: 30px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  .header-nav-m-menu-wrapper .img-menu{
    width: 100%;
    height: 100%;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    /* background: #474747; */
    background: rgba(8,17,32,0.85);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue